import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  position: relative;
`;

export const IconWrapper = styled.div`
  position: absolute;
  top: 42px;
  right: 20px;
  height: 20px;
  width: 20px;
  color: var(--gray-9);
`;

export const NotFoundItem = styled.button`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 60px;
  border-radius: 8px;
  background: var(--white-darker);
  padding: 0 20px;
  font-weight: 500;
  cursor: pointer;

  > p {
    font-size: 14px;
    color: var(--black-2);
  }

  > span {
    font-size: 14px;
    color: var(--info);
    background: var(--info-transparent);
    border-radius: 20px;
    padding: 5px 15px;
  }
`;

export const Row = styled.div`
  display: grid;
  grid-template-columns: auto 50px;

  > button {
    cursor: pointer;
    background: var(--white-darker);
    border-radius: 0 4px 4px 0;
  }

  > div {
    border-radius: 4px 0 0 4px;
  }
`;
